module.exports = __webpack_public_path__ + "assets/YayCircle.fb709c2a.svg";